export class WbBackToTop {
  constructor() {
    this.init();
  }

  init() {
    const _this = this;

    return new Promise((resolve) => {
      window.addEventListener('scroll', function () {
        const backToTop = document.querySelector('.back-top');
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
          backToTop.classList.add('visible');
        } else {
          backToTop.classList.remove('visible');
        }
      });
      document.querySelector('body')._addCustomEventListener('click', '.back-top', _this.scrollToTop.bind(_this));

      resolve();
    });
  }

  scrollToTop() {
    WbScrollTo.scrollTo({ element: 'body' });
  }
}
